import React from 'react';

// A simple stylized chat bubble with sparkles to imply "AI / interactive"
const InteractiveChatIcon: React.FC<{ active?: boolean; size?: number }> = ({ active, size = 22 }) => {
  const gradientId = 'chatIconGradient';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Interactive Chat"
    >
      <defs>
        <linearGradient id={gradientId} x1="4" y1="4" x2="44" y2="44" gradientUnits="userSpaceOnUse">
          <stop stopColor={active ? '#fde047' : '#64748b'} />
          <stop offset="1" stopColor={active ? '#f59e0b' : '#475569'} />
        </linearGradient>
      </defs>
      <path
        d="M10 8h28c3.3 0 6 2.7 6 6v11c0 3.3-2.7 6-6 6h-9.8c-1 .0-1.96.4-2.66 1.1L18 39.5c-.94.94-2.56.27-2.56-1.06V33H10c-3.3 0-6-2.7-6-6V14c0-3.3 2.7-6 6-6Z"
        stroke={`url(#${gradientId})`}
        strokeWidth={2.8}
        fill={active ? 'rgba(250,204,21,0.08)' : 'rgba(100,116,139,0.08)'}
        strokeLinejoin="round"
      />
      <circle cx="18" cy="20" r="2.4" fill={`url(#${gradientId})`} />
      <circle cx="24" cy="20" r="2.4" fill={`url(#${gradientId})`} />
      <circle cx="30" cy="20" r="2.4" fill={`url(#${gradientId})`} />
      <path
        d="M36 6.5 37.8 9l2.7.6-2 2.3.3 2.8L36 13.4l-2.8 1.3.3-2.8-2-2.3 2.7-.6L36 6.5Z"
        fill={active ? '#facc15' : '#475569'}
      />
    </svg>
  );
};

export default InteractiveChatIcon;
